module.exports = __webpack_public_path__ + "img/login-v2-dark.6e16862b.svg";